module.exports = __webpack_public_path__ + "static/media/polrev.5b291f77.png";